// editors/markdoc/decorations/headings.js
import { Decoration } from "@codemirror/view";

import { syntaxTree } from "@codemirror/language";
import { findMarkerPositions, hiddenDecoration, shouldHideMarkers } from "../utils/decorationHelper";

export function decorateATXHeading(node, view, widgets, mode) {
  if (node.from >= node.to) return false;

  const level = parseInt(node.name.replace("ATXHeading", "")) || 1;

  // Calculate marker positions
  const hashSymbolsLength = level;
  const spaceAfterHashLength = 1;
  const tree = syntaxTree(view.state);
  const { markStart } = findMarkerPositions(tree, node.from, node.to, `ATXHeading${level}`);

  // Adjust marker position to cover only the hash symbols
  markStart.to = markStart.from + hashSymbolsLength;

  if (shouldHideMarkers(view, node, mode)) {
    widgets.push(hiddenDecoration(markStart.from, markStart.to + spaceAfterHashLength));
  }

  return false;
}
